import { type GetServerSidePropsContext } from 'next'
import { getBucket } from '@mc/next-growthbook'

export const LESSONS_ON_QR_EXP_NAME = 'pen-4824_v1'

export const getIsLessonsOnQRVariant1Server = async (
  ctx: GetServerSidePropsContext,
) => {
  const bucket = await getBucket(ctx, LESSONS_ON_QR_EXP_NAME)
  return bucket && bucket === 'variant_1'
}
